<script lang="ts">
	import { ArrowForward } from "luxedo-icons"
	import type { ContextMenuOption, ContextMenuOptions } from "./ContextMenuTypes"
	import { LoadingSpinner } from "misc-ui"

	interface Props {
		option: ContextMenuOption
		openSubmenu: (
			e: MouseEvent & {
				currentTarget: EventTarget & HTMLButtonElement
			},
			options: ContextMenuOptions,
			buttonIndex: number,
		) => void
		closeCtxMenu: () => void
		elem: HTMLButtonElement
		index: number
	}

	let { option, elem = $bindable(), index, openSubmenu, closeCtxMenu }: Props = $props()
	let isLoading = $state(false)

	async function handleClick(
		e: MouseEvent & {
			currentTarget: EventTarget & HTMLButtonElement
		},
	) {
		if ("hasSubmenu" in option) {
			openSubmenu(e, option.submenu, index)
		} else if ("onClick" in option) {
			isLoading = true
			try {
				await option?.onClick?.(e)
			} catch (e) {
				console.error("Error while handling context menu click...", e)
			}
			isLoading = false
			closeCtxMenu()
		}
	}
</script>

{#if "title" in option && option.title}
	<button
		bind:this={elem}
		disabled={isLoading}
		tabindex={index + 1}
		onfocus={(e) => {
			if ("onMouseOver" in option && option.onMouseOver) option.onMouseOver()
		}}
		onmouseover={(e) => {
			if ("onMouseOver" in option && option.onMouseOver) option.onMouseOver(e)
		}}
		onmouseleave={(e) => {
			if ("onMouseLeave" in option && option.onMouseLeave) option.onMouseLeave(e)
		}}
		onclick={handleClick}
		style={option.style}
		class="icon ctxMenuOpt"
	>
		{#if "icon" in option}
			<option.icon />
		{/if}
		{#if isLoading}
			<LoadingSpinner color="var(--color-main)" height="1rem" margin="0 .25rem 0 0" />
		{/if}
		{option.title}
		{#if "hasSubmenu" in option}
			<ArrowForward strokeColor="var(--color-text-light)" />
			<!-- {:else if "icon" in option}
						<svelte:component this={option.icon} /> -->
		{/if}
		{#if "shortcut" in option}
			<span class="ctx-menu-keyboard-shortcut">
				{option.shortcut}
			</span>
		{/if}
	</button>
{:else if "comp" in option}
	<option.comp {...option.props} />
{/if}

<style>
	.ctx-menu-keyboard-shortcut {
		position: absolute;
		right: 0;
		color: var(--color-text);
	}

	button :global(svg) {
		padding: 0.25rem;
	}
</style>
